export default{
    namespaced: true,
    state:{
        headers: [
            { text: "", value: "importante", sortable: false, width: "10px" },
            { text: "DATA", value: "data", sortable: false },
            { text: "MENSAGENS", value: "mensagem", sortable: false },
        ],
        mensagens: []
    },
    getters:{

    },
    mutations:{
        SET_MENSAGENS(state, value){
            state.mensagens = value;
        },
        SET_MARCA_COMO_LIDAS(state){
            state.mensagens.map(x => x.lida =  false);
        }
    },
    actions:{
        limpar({ commit }){
            commit('SET_MENSAGENS',[]);
        },
        marcarComoLidas({ commit }){       
           commit('SET_MARCA_COMO_LIDAS');
        },
        obtemNotificacoes({ commit }){
          //TODO: Usar a Api para carregar as notificações
          let mensagens = [
            {
              id: 1,
              importante: false,
              data: "15/04/2020",
              mensagem:
                "Recomendamos que a senha do administrador seja trocada semanalmente",
              lida: false
            },
            {
              id: 2,
              importante: true,
              data: "13/04/2020",
              mensagem:
                "Fizemos algumas atualizações no sistema. Conheça as novidades!",
              lida: false
            },
            {
              id: 3,
              importante: true,
              data: "13/04/2020",
              mensagem:
                "Fizemos algumas atualizações no sistema. Conheça as novidades!",
              lida: true
            },
            {
              id: 4,
              importante: true,
              data: "13/04/2020",
              mensagem:
                "Fizemos algumas atualizações no sistema. Conheça as novidades!",
              lida: true
            },
            {
              id: 5,
              importante: true,
              data: "13/04/2020",
              mensagem:
                "Fizemos algumas atualizações no sistema. Conheça as novidades!",
              lida: true
            }
          ];
          commit('SET_MENSAGENS', mensagens);
        }
    }    
}